/** The "already in the library" question during an import, answered by `DuplicateDialog`. */
import { create } from 'zustand';
import type { DuplicateAnswer, DuplicateQuestion } from '../media/duplicates.ts';

interface PromptState {
  question: DuplicateQuestion | null;
  answer(answer: DuplicateAnswer): void;
}

export const useDuplicatePrompt = create<PromptState>()(() => ({ question: null, answer: () => undefined }));

/** Shows the question and resolves with the user's choice. Questions are asked one at a time. */
let queue: Promise<unknown> = Promise.resolve();
export function askDuplicate(question: DuplicateQuestion): Promise<DuplicateAnswer> {
  const asked = queue.then(
    () =>
      new Promise<DuplicateAnswer>((resolve) =>
        useDuplicatePrompt.setState({
          question,
          answer(answer) {
            useDuplicatePrompt.setState({ question: null, answer: () => undefined });
            resolve(answer);
          },
        }),
      ),
  );
  queue = asked;
  return asked;
}
